import React, { useEffect } from 'react';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const AttachmentPreview = ({ data }) => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  const attachments = data?.attachementPath || [];

  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: { autoStart: true },
      Toolbar: {
        display: [
          'zoom',
          'slideshow',
          'fullscreen',
          'download',
          'thumbs',
          'close',
        ],
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  const getFullUrl = (url) => `${process.env.REACT_APP_IMAGE_URL || ''}/${url}`;

  return (
    <div className="attachment-preview mt-2 d-flex gap-2 flex-wrap items-center justify-center">
      {attachments.map((url, idx) => {
        const fullUrl = getFullUrl(url);
        const ext = url.split('.').pop().toLowerCase();


        if (imageExtensions.includes(ext)) {
          return (
            <a
              key={idx}
              href={fullUrl}
              data-fancybox="gallery"
              data-caption={`Image ${idx + 1}`}
            >
              <img
                src={fullUrl}
                alt="attachment"
                style={{
                  maxWidth: 220,
                  maxHeight: 220,
                  borderRadius: 8,
                  cursor: 'pointer',
                }}
              />
            </a>
          );
        }

        if (ext === 'pdf') {
          return (
            <a
              key={idx}
              href={fullUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 120,
                height: 120,
                border: '1px solid #ccc',
                borderRadius: 8,
                backgroundColor: '#fef2f2',
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 'bold',
                color: '#b91c1c',
                flexDirection: 'column',
                gap: 8,
              }}
            >
              📄 View PDF
            </a>
          );
        }

        return (
          <div
            key={idx}
            style={{
              width: 120,
              height: 120,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #ccc',
              borderRadius: 8,
              fontSize: 12,
              backgroundColor: '#f5f5f5',
            }}
          >
            Unknown file
          </div>
        );
      })}
    </div>
  );
};

export default AttachmentPreview;
